package org.braunequip.web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.icons.fa.FaFaceSmile
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import org.braunequip.web.util.Theme
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

@Page("oops")
@Composable
fun OnTheWayPage() {
    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        Column(Modifier, horizontalAlignment = Alignment.CenterHorizontally) {
            Row(Modifier.fillMaxWidth().gap(1.5.cssRem), verticalAlignment = Alignment.CenterVertically) {
                FaFaceSmile(modifier = Modifier.color(Theme.Primary.rgb).fontSize(3.cssRem), size = IconSize.XL, style = IconStyle.FILLED)
                H1(Modifier.color(Colors.White).toAttrs()) {
                    Text("Oops! This is still on the way.")
                }
            }
            Row(Modifier) {
                Link("/", Modifier.fillMaxWidth().color(Theme.PrimaryGreen.rgb).fontSize(1.5.cssRem), variant = UndecoratedLinkVariant.then(
                    UncoloredLinkVariant
                )) {
                    Text("to home page..")
                }
            }
        }
    }
}